import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["Devices"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      putAnalogDataChannel: build.mutation<
        PutAnalogDataChannelApiResponse,
        PutAnalogDataChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/AnalogDataChannels/${queryArg.channelKey}`,
          method: "PUT",
          body: queryArg.putAnalogDataChannelDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      getBatteryStatusHistory: build.query<
        GetBatteryStatusHistoryApiResponse,
        GetBatteryStatusHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Battery/StatusHistory`,
        }),
        providesTags: ["Devices"],
      }),
      putCalibratableElectricCurrentDataChannels: build.mutation<
        PutCalibratableElectricCurrentDataChannelsApiResponse,
        PutCalibratableElectricCurrentDataChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/CalibratableElectricCurrent`,
          method: "PUT",
          body: queryArg.putCalibratableElectricCurrentDataChannelsDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putCalibratableFlowDataChannels: build.mutation<
        PutCalibratableFlowDataChannelsApiResponse,
        PutCalibratableFlowDataChannelsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/CalibratableFlowDataChannels`,
          method: "PUT",
          body: queryArg.putCalibratableFlowDataChannelsDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putDataIntervalConfiguration: build.mutation<
        PutDataIntervalConfigurationApiResponse,
        PutDataIntervalConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/DataIntervalConfiguration`,
          method: "PUT",
          body: queryArg.putDataIntervalConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      getGatewayConnectionInfo: build.query<
        GetGatewayConnectionInfoApiResponse,
        GetGatewayConnectionInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Gateway/ConnectionInfo`,
        }),
        providesTags: ["Devices"],
      }),
      putHeatingControl: build.mutation<
        PutHeatingControlApiResponse,
        PutHeatingControlApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/HeatingControl`,
          method: "PUT",
          body: queryArg.putHeatingControlDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putHeatingControlActuatorChannel: build.mutation<
        PutHeatingControlActuatorChannelApiResponse,
        PutHeatingControlActuatorChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/HeatingControl/ActuatorChannels/${queryArg.channelKey}`,
          method: "PUT",
          body: queryArg.putHeatingControlActuatorChannelDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      getHeatingControlActuatorChannelWeekplan: build.query<
        GetHeatingControlActuatorChannelWeekplanApiResponse,
        GetHeatingControlActuatorChannelWeekplanApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/HeatingControl/ActuatorChannels/${queryArg.channelKey}/Weekplan`,
        }),
        providesTags: ["Devices"],
      }),
      putHeatingControlActuatorChannelWeekplan: build.mutation<
        PutHeatingControlActuatorChannelWeekplanApiResponse,
        PutHeatingControlActuatorChannelWeekplanApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/HeatingControl/ActuatorChannels/${queryArg.channelKey}/Weekplan`,
          method: "PUT",
          body: queryArg.putHeatingControlActuatorChannelWeekplanDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      deleteHeatingControlActuatorChannelWeekplan: build.mutation<
        DeleteHeatingControlActuatorChannelWeekplanApiResponse,
        DeleteHeatingControlActuatorChannelWeekplanApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/HeatingControl/ActuatorChannels/${queryArg.channelKey}/Weekplan`,
          method: "DELETE",
        }),
        invalidatesTags: ["Devices"],
      }),
      putMBus: build.mutation<PutMBusApiResponse, PutMBusApiArg>({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/MBus`,
          method: "PUT",
          body: queryArg.putMBusDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putMBusDataChannel: build.mutation<
        PutMBusDataChannelApiResponse,
        PutMBusDataChannelApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/MBus/${queryArg.channelKey}`,
          method: "PUT",
          body: queryArg.putMBusDataChannelDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      postOptoEye: build.mutation<PostOptoEyeApiResponse, PostOptoEyeApiArg>({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Optoeye`,
          method: "POST",
          body: queryArg.postOptoeyeDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      deleteOptoEye: build.mutation<
        DeleteOptoEyeApiResponse,
        DeleteOptoEyeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Optoeye`,
          method: "DELETE",
        }),
        invalidatesTags: ["Devices"],
      }),
      putPluginActuatorChannelConfiguration: build.mutation<
        PutPluginActuatorChannelConfigurationApiResponse,
        PutPluginActuatorChannelConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/${queryArg.pluginName}/ActuatorChannels/${queryArg.channelKey}/Configuration`,
          method: "PUT",
          body: queryArg.putPluginActuatorChannelConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putPluginConfiguration: build.mutation<
        PutPluginConfigurationApiResponse,
        PutPluginConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/${queryArg.pluginName}/Configuration`,
          method: "PUT",
          body: queryArg.putPluginConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putPluginDataChannelConfiguration: build.mutation<
        PutPluginDataChannelConfigurationApiResponse,
        PutPluginDataChannelConfigurationApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/${queryArg.pluginName}/DataChannels/${queryArg.channelKey}/Configuration`,
          method: "PUT",
          body: queryArg.putPluginDataChannelConfigurationDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      putProductionInfo: build.mutation<
        PutProductionInfoApiResponse,
        PutProductionInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/ProductionInfo`,
          method: "PUT",
        }),
        invalidatesTags: ["Devices"],
      }),
      getDevice: build.query<GetDeviceApiResponse, GetDeviceApiArg>({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}`,
          params: {
            includeFields: queryArg.includeFields,
          },
        }),
        providesTags: ["Devices"],
      }),
      putDevice: build.mutation<PutDeviceApiResponse, PutDeviceApiArg>({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}`,
          method: "PUT",
          body: queryArg.putDeviceDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      deleteDevice: build.mutation<DeleteDeviceApiResponse, DeleteDeviceApiArg>(
        {
          query: (queryArg) => ({
            url: `/v2/Devices/${queryArg.deviceId}`,
            method: "DELETE",
          }),
          invalidatesTags: ["Devices"],
        },
      ),
      getDevices: build.query<GetDevicesApiResponse, GetDevicesApiArg>({
        query: (queryArg) => ({
          url: `/v2/Devices`,
          params: {
            AccountIds: queryArg.accountIds,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            includeFields: queryArg.includeFields,
            type: queryArg["type"],
            canProduceDataType: queryArg.canProduceDataType,
          },
        }),
        providesTags: ["Devices"],
      }),
      postMbusDevice: build.mutation<
        PostMbusDeviceApiResponse,
        PostMbusDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/Mbus`,
          method: "POST",
          body: queryArg.postMbusDeviceDto,
        }),
        invalidatesTags: ["Devices"],
      }),
      getDeviceActivity: build.query<
        GetDeviceActivityApiResponse,
        GetDeviceActivityApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Activity`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            OrderBy: queryArg.orderBy,
            OrderDirection: queryArg.orderDirection,
            Top: queryArg.top,
            Skip: queryArg.skip,
            activityType: queryArg.activityType,
          },
        }),
        providesTags: ["Devices"],
      }),
      getDeviceImage: build.query<
        GetDeviceImageApiResponse,
        GetDeviceImageApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Image`,
        }),
        providesTags: ["Devices"],
      }),
      putDeviceImage: build.mutation<
        PutDeviceImageApiResponse,
        PutDeviceImageApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Image`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["Devices"],
      }),
      deleteDeviceImage: build.mutation<
        DeleteDeviceImageApiResponse,
        DeleteDeviceImageApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Devices/${queryArg.deviceId}/Image`,
          method: "DELETE",
        }),
        invalidatesTags: ["Devices"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type PutAnalogDataChannelApiResponse = unknown;
export type PutAnalogDataChannelApiArg = {
  deviceId: number;
  channelKey: string;
  putAnalogDataChannelDto: PutAnalogDataChannelDto;
};
export type GetBatteryStatusHistoryApiResponse =
  /** status 200 OK */ GetBatteryStatusHistoryDto[];
export type GetBatteryStatusHistoryApiArg = {
  deviceId: number;
};
export type PutCalibratableElectricCurrentDataChannelsApiResponse = unknown;
export type PutCalibratableElectricCurrentDataChannelsApiArg = {
  deviceId: number;
  putCalibratableElectricCurrentDataChannelsDto: PutCalibratableElectricCurrentDataChannelsDto;
};
export type PutCalibratableFlowDataChannelsApiResponse = unknown;
export type PutCalibratableFlowDataChannelsApiArg = {
  deviceId: number;
  putCalibratableFlowDataChannelsDto: PutCalibratableFlowDataChannelsDto;
};
export type PutDataIntervalConfigurationApiResponse = unknown;
export type PutDataIntervalConfigurationApiArg = {
  deviceId: number;
  putDataIntervalConfigurationDto: PutDataIntervalConfigurationDto;
};
export type GetGatewayConnectionInfoApiResponse =
  /** status 200 OK */ GetGatewayConnectionInfoDto[];
export type GetGatewayConnectionInfoApiArg = {
  deviceId: number;
};
export type PutHeatingControlApiResponse = unknown;
export type PutHeatingControlApiArg = {
  deviceId: number;
  putHeatingControlDto: PutHeatingControlDto;
};
export type PutHeatingControlActuatorChannelApiResponse =
  /** status 200 OK */ GetHeatingControlActuatorChannelWeekplanDto;
export type PutHeatingControlActuatorChannelApiArg = {
  deviceId: number;
  channelKey: string;
  putHeatingControlActuatorChannelDto: PutHeatingControlActuatorChannelDto;
};
export type GetHeatingControlActuatorChannelWeekplanApiResponse = unknown;
export type GetHeatingControlActuatorChannelWeekplanApiArg = {
  deviceId: number;
  channelKey: string;
};
export type PutHeatingControlActuatorChannelWeekplanApiResponse = unknown;
export type PutHeatingControlActuatorChannelWeekplanApiArg = {
  deviceId: number;
  channelKey: string;
  putHeatingControlActuatorChannelWeekplanDto: PutHeatingControlActuatorChannelWeekplanDto;
};
export type DeleteHeatingControlActuatorChannelWeekplanApiResponse = unknown;
export type DeleteHeatingControlActuatorChannelWeekplanApiArg = {
  deviceId: number;
  channelKey: string;
};
export type PutMBusApiResponse = unknown;
export type PutMBusApiArg = {
  deviceId: number;
  putMBusDto: PutMBusDto;
};
export type PutMBusDataChannelApiResponse = unknown;
export type PutMBusDataChannelApiArg = {
  deviceId: number;
  channelKey: string;
  putMBusDataChannelDto: PutMBusDataChannelDto;
};
export type PostOptoEyeApiResponse = unknown;
export type PostOptoEyeApiArg = {
  deviceId: number;
  postOptoeyeDto: PostOptoeyeDto;
};
export type DeleteOptoEyeApiResponse = unknown;
export type DeleteOptoEyeApiArg = {
  deviceId: number;
};
export type PutPluginActuatorChannelConfigurationApiResponse = unknown;
export type PutPluginActuatorChannelConfigurationApiArg = {
  deviceId: number;
  pluginName: string;
  channelKey: string;
  putPluginActuatorChannelConfigurationDto: PutPluginActuatorChannelConfigurationDto;
};
export type PutPluginConfigurationApiResponse = unknown;
export type PutPluginConfigurationApiArg = {
  deviceId: number;
  pluginName: string;
  putPluginConfigurationDto: PutPluginConfigurationDto;
};
export type PutPluginDataChannelConfigurationApiResponse = unknown;
export type PutPluginDataChannelConfigurationApiArg = {
  deviceId: number;
  pluginName: string;
  channelKey: string;
  putPluginDataChannelConfigurationDto: PutPluginDataChannelConfigurationDto;
};
export type PutProductionInfoApiResponse =
  /** status 200 OK */ GetProductionInfoHistoryDto;
export type PutProductionInfoApiArg = {
  deviceId: number;
};
export type GetDeviceApiResponse = /** status 200 OK */ GetDeviceDto;
export type GetDeviceApiArg = {
  deviceId: number;
  includeFields?: GetDeviceOptionalFields[];
};
export type PutDeviceApiResponse = unknown;
export type PutDeviceApiArg = {
  deviceId: number;
  putDeviceDto: PutDeviceDto;
};
export type DeleteDeviceApiResponse = unknown;
export type DeleteDeviceApiArg = {
  deviceId: number;
};
export type GetDevicesApiResponse = /** status 200 OK */ GetDeviceDto[];
export type GetDevicesApiArg = {
  accountIds?: number[];
  orderBy?: "deviceId";
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  includeFields?: GetDeviceOptionalFields[];
  type?: DeviceType;
  canProduceDataType?: string;
};
export type PostMbusDeviceApiResponse = /** status 201 Created */ GetDeviceDto;
export type PostMbusDeviceApiArg = {
  postMbusDeviceDto: PostMbusDeviceDto;
};
export type GetDeviceActivityApiResponse =
  /** status 200 OK */ GetDeviceActivityDto[];
export type GetDeviceActivityApiArg = {
  deviceId: number;
  from?: string;
  to?: string;
  orderBy?: "lastActivity";
  orderDirection?: "desc" | "asc";
  top?: number;
  skip?: number;
  activityType?: DeviceActivityDirectionFilter;
};
export type GetDeviceImageApiResponse = /** status 200 OK */ Blob;
export type GetDeviceImageApiArg = {
  deviceId: number;
};
export type PutDeviceImageApiResponse = unknown;
export type PutDeviceImageApiArg = {
  deviceId: number;
  body: {
    image?: Blob;
  };
};
export type DeleteDeviceImageApiResponse = unknown;
export type DeleteDeviceImageApiArg = {
  deviceId: number;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PutAnalogDataChannelDto = {
  targetDataType?: string | null;
  conversionFactor?: number | null;
  conversionOffset?: number | null;
};
export type GetBatteryStatusHistoryDto = object;
export type CalibrationType =
  | "Level2ApparentPower"
  | "Level2Current"
  | "PowerDisaggregation"
  | "Level1";
export type PutCalibratableElectricCurrentDataChannelsDto = {
  calibrationType?: CalibrationType;
  calibrationFactor?: number | null;
};
export type PutCalibratableFlowDataChannelsDto = {
  volumeConstant?: number | null;
  flowPipeDiameter?: number | null;
};
export type DataInterval =
  | "Minute"
  | "Minutes5"
  | "Seconds20Boost"
  | "Seconds3Boost"
  | "Minutes30"
  | "Inactive"
  | "Second"
  | "Custom";
export type PutDataIntervalConfigurationDto = {
  dataInterval?: DataInterval;
};
export type GetGatewayConnectionInfoDto = object;
export type PutHeatingControlDto = object;
export type GetHeatingControlActuatorChannelWeekplanDto = object;
export type PutHeatingControlActuatorChannelDto = object;
export type PutHeatingControlActuatorChannelWeekplanDto = object;
export type PutMBusDto = {
  wireless?: boolean;
  mBusDeviceId?: string | null;
  encryptionKey?: string | null;
};
export type PutMBusDataChannelDto = {
  targetDataType?: string | null;
  conversionFactor?: number;
  conversionOffset?: number;
};
export type OptoEyeTargetDeviceType =
  | "KamstrupMultical21"
  | "KamstrupFlowIQ2100"
  | "KamstrupFlowIQ3100"
  | "KamstrupMultical302"
  | "KamstrupMultical403"
  | "KamstrupMultical602"
  | "KamstrupMultical603";
export type PostOptoeyeDto = {
  targetDeviceType?: OptoEyeTargetDeviceType;
};
export type PutPluginActuatorChannelConfigurationDto = object;
export type PutPluginConfigurationDto = object;
export type PutPluginDataChannelConfigurationDto = object;
export type GetProductionInfoHistoryDto = object;
export type GetDeviceTagDto = {
  key?: string | null;
  value?: string | null;
};
export type GetDeviceLocationDto = {
  latitude?: number;
  longitude?: number;
  accuracyInMeters?: number | null;
  locationSource?: string | null;
  address?: string | null;
  addressAutoLookup?: boolean | null;
};
export type GetCapabilityBaseDtoBase = {
  $type: string;
  name?: string | null;
};
export type GetDataChannelBaseDtoBase = {
  $type: string;
  dataChannelId?: number;
  currentlyProducingDataTypes?: string[] | null;
  potentialDataTypes?: string[] | null;
  displayName?: string | null;
  channelKey?: string | null;
  description?: string | null;
};
export type GetAnalogDataChannelDto = {
  $type: "Analog";
} & GetDataChannelBaseDtoBase & {
    targetDataType?: string | null;
    conversionFactor?: number | null;
    conversionOffset?: number | null;
  };
export type GetAnalogDataChannelsCapabilityDto = {
  $type: "AnalogDataChannels";
} & GetCapabilityBaseDtoBase & {
    dataChannels?: GetAnalogDataChannelDto[] | null;
  };
export type GetBasicDataChannelDto = {
  $type: "Basic";
} & GetDataChannelBaseDtoBase &
  object;
export type GetBasicDataChannelsCapabilityDto = {
  $type: "BasicDataChannels";
} & GetCapabilityBaseDtoBase & {
    dataChannels?: GetBasicDataChannelDto[] | null;
  };
export type GetBatteryCapabilityDto = {
  $type: "Battery";
} & GetCapabilityBaseDtoBase & {
    batteryStatusHistoryUrl?: string | null;
  };
export type GetCalibratableElectricCurrentDataChannelDto = {
  $type: "CalibratableElectricCurrent";
} & GetDataChannelBaseDtoBase &
  object;
export type GetCalibratableElectricCurrentDataChannelsCapabilityDto = {
  $type: "CalibratableElectricCurrentDataChannels";
} & GetCapabilityBaseDtoBase & {
    calibrationType?: string | null;
    calibrationFactor?: number | null;
    dataChannels?: GetCalibratableElectricCurrentDataChannelDto[] | null;
  };
export type GetCalibratableFlowDataChannelDto = {
  $type: "CalibratableFlow";
} & GetDataChannelBaseDtoBase &
  object;
export type GetCalibratableFlowDataChannelsCapabilityDto = {
  $type: "CalibratableFlowDataChannels";
} & GetCapabilityBaseDtoBase & {
    volumeConstant?: number | null;
    targetVolumeConstant?: number | null;
    flowGap?: number | null;
    targetFlowGap?: number | null;
    enforceFlowParams?: boolean;
    flowPipeDiameter?: number | null;
    hardwareVersion?: string | null;
    configLastReported?: string | null;
    lastConfigReadRequestSent?: string | null;
    lastConfigWriteRequestSent?: string | null;
    dataChannels?: GetCalibratableFlowDataChannelDto[] | null;
  };
export type GetIntervalConfigurationDto = {
  transmitInterval?: number;
  sampleInterval?: number;
  aliveInterval?: number;
};
export type GetTargetTempIntervalConfigurationDto = {
  currentTempTransmitInterval?: number;
  currentTempSampleInterval?: number;
  targetTempConfigTimeout?: number;
};
export type GetDataIntervalConfigurationCapabilityDto = {
  $type: "DataIntervalConfiguration";
} & GetCapabilityBaseDtoBase & {
    currentIntervalConfiguration?: GetIntervalConfigurationDto;
    targetIntervalConfiguration?: GetIntervalConfigurationDto;
    currentTempIntervalConfiguration?: GetIntervalConfigurationDto;
    targetTempIntervalConfiguration?: GetTargetTempIntervalConfigurationDto;
    intervalMode?: string | null;
    targetIntervalMode?: string | null;
    configLastReported?: string | null;
    lastConfigReadRequestSent?: string | null;
    lastConfigWriteRequestSent?: string | null;
    synchronized?: boolean;
  };
export type GetGatewayCapabilityDto = {
  $type: "Gateway";
} & GetCapabilityBaseDtoBase & {
    lastOnlineTimestamp?: string | null;
    softwareVersion?: string | null;
    hardwareVersion?: string | null;
    apMode?: string | null;
    targetApMode?: string | null;
    upstreamProtocol?: string | null;
    reportedGatewayCapabilities?: string[] | null;
    platform?: string | null;
    lastStatusTimestamp?: string | null;
    sdCardDetected?: boolean;
    connectionInfoUrl?: string | null;
    online?: boolean;
  };
export type ValueType = "Boolean" | "Float" | "Int" | "String";
export type GetActuatorChannelBaseDtoBase = {
  $type: string;
  actuatorChannelId?: number;
  valueType?: ValueType;
  targetValue?: any | null;
  displayName?: string | null;
  key?: string | null;
  confirmedValue?: any | null;
  defaultValue?: any | null;
  minValue?: any | null;
  maxValue?: any | null;
};
export type TemperatureOverrideResistor = "Pt100" | "Pt1000" | "Ntc" | "Custom";
export type GetTemperatureOverrideActuatorChannelDto = {
  $type: "TemperatureOverride";
} & GetActuatorChannelBaseDtoBase & {
    temperatureOverrideResistor?: TemperatureOverrideResistor;
  };
export type GetHeatingControlCapabilityDto = {
  $type: "HeatingControl";
} & GetCapabilityBaseDtoBase & {
    controlActive?: boolean;
    dataChannels?: GetTemperatureOverrideActuatorChannelDto[] | null;
  };
export type MBusState = "Unconfirmed" | "Ok";
export type MBusSensorType =
  | "KamstrupMultical21"
  | "KamstrupFlowIQXX00Series"
  | "KamstrupMultical302"
  | "KamstrupMultical603"
  | "KamstrupMultical403"
  | "KamstrupMultical602"
  | "DiehlHydrusWaterMeter"
  | "DiehlSharkyHeatMeter"
  | "CarloGavazziEm24"
  | "HydrometerSharkyHeatMeter";
export type GetMBusDataChannelDto = {
  $type: "MBus";
} & GetDataChannelBaseDtoBase & {
    mBusDataType?: string | null;
    targetDataType?: string | null;
    conversionFactor?: number | null;
    conversionOffset?: number | null;
  };
export type GetMBusSensorCapabilityDto = {
  $type: "MBusSensor";
} & GetCapabilityBaseDtoBase & {
    wireless?: boolean;
    mBusDeviceId?: string | null;
    mBusState?: MBusState | null;
    encryptionKey?: string | null;
    mBusDeviceKey?: string | null;
    manufacturerCode?: string | null;
    mBusSensorType?: MBusSensorType;
    dataChannels?: GetMBusDataChannelDto[] | null;
  };
export type GetOptoEyeDataChannelDto = {
  $type: "OptoEye";
} & GetDataChannelBaseDtoBase &
  object;
export type GetOptoEyeCapabilityDto = {
  $type: "OptoEye";
} & GetCapabilityBaseDtoBase & {
    targetDeviceType?: OptoEyeTargetDeviceType;
    dataChannels?: GetOptoEyeDataChannelDto[] | null;
  };
export type GetPluginModuleConfigurationItemDto = {
  value?: any | null;
  lastWrite?: string | null;
  lastRead?: string | null;
  valueType?: ValueType;
  min?: number | null;
  max?: number | null;
  writable?: boolean;
  readable?: boolean;
};
export type GetPluginModuleDataChannelDto = {
  $type: "PluginModule";
} & GetDataChannelBaseDtoBase & {
    channelNumber?: number | null;
    moduleChannelDataType?: string | null;
    moduleChannelUnit?: string | null;
    configuration?: {
      [key: string]: GetPluginModuleConfigurationItemDto;
    } | null;
  };
export type GetPluginModuleActuatorChannelDto = {
  $type: "PluginModule";
} & GetActuatorChannelBaseDtoBase & {
    actuatorType?: string | null;
    configuration?: {
      [key: string]: GetPluginModuleConfigurationItemDto;
    } | null;
  };
export type GetPluginModuleCapabilityDto = {
  $type: "PluginModule";
} & GetCapabilityBaseDtoBase & {
    moduleType?: string | null;
    hardwareVersion?: string | null;
    softwareVersion?: string | null;
    configuration?: {
      [key: string]: GetPluginModuleConfigurationItemDto;
    } | null;
    dataChannels?: GetPluginModuleDataChannelDto[] | null;
    actuatorChannels?: GetPluginModuleActuatorChannelDto[] | null;
  };
export type GetProductionInfoCapabilityDto = {
  $type: "ProductionInfo";
} & GetCapabilityBaseDtoBase & {
    statusChangedTimestamp?: string | null;
    status?: string | null;
    statusHistoryUrl?: string | null;
  };
export type GetRfuCapabilityDto = {
  $type: "Rfu";
} & GetCapabilityBaseDtoBase & {
    rfuId?: number;
    supportsEncryption?: boolean;
    hardwareVersion?: string | null;
    initialFirmwareVersion?: string | null;
    currentFirmwareVersion?: string | null;
    pairedRfuId?: number | null;
  };
export type GetCapabilityBaseDto =
  | GetAnalogDataChannelsCapabilityDto
  | GetBasicDataChannelsCapabilityDto
  | GetBatteryCapabilityDto
  | GetCalibratableElectricCurrentDataChannelsCapabilityDto
  | GetCalibratableFlowDataChannelsCapabilityDto
  | GetDataIntervalConfigurationCapabilityDto
  | GetGatewayCapabilityDto
  | GetHeatingControlCapabilityDto
  | GetMBusSensorCapabilityDto
  | GetOptoEyeCapabilityDto
  | GetPluginModuleCapabilityDto
  | GetProductionInfoCapabilityDto
  | GetRfuCapabilityDto;
export type DeviceActivityType = "Rfu" | "MBus" | "OptoEye";
export type GetDeviceActivityDto = {
  sourceDeviceId?: number;
  targetDeviceId?: number | null;
  gatewayId?: number | null;
  lastActivity?: string;
  activityType?: DeviceActivityType;
  rssi?: number | null;
};
export type GetDeviceUnitDto = {
  unitId?: number;
  unitName?: string | null;
  unitType?: string | null;
  unitTypeInputId?: number;
  unitTypeInputName?: string | null;
};
export type GetDeviceOptionalFields = "MappedUnits";
export type GetDeviceDto = {
  deviceId?: number;
  deviceType?: string | null;
  accountId?: number;
  displayName?: string | null;
  description?: string | null;
  tags?: GetDeviceTagDto[] | null;
  location?: GetDeviceLocationDto;
  imageHash?: number | null;
  imageUrl?: string | null;
  capabilities?: {
    [key: string]: GetCapabilityBaseDto;
  } | null;
  latestSourceActivity?: GetDeviceActivityDto;
  latestTargetActivity?: GetDeviceActivityDto;
  activityUrl?: string | null;
  mappedUnits?: GetDeviceUnitDto[] | null;
  includedOptionalFields?: GetDeviceOptionalFields[] | null;
};
export type PutDeviceTagDto = {
  key?: string | null;
  value?: string | null;
};
export type LocationSource =
  | "GPS"
  | "WifiAssisted"
  | "IpLookup"
  | "Manual"
  | "AddressLookup"
  | "Unknown";
export type PutDeviceLocationDto = {
  latitude?: number | null;
  longitude?: number | null;
  accuracyInMeters?: number | null;
  locationSource?: LocationSource | null;
  address?: string | null;
  addressAutoLookup?: boolean | null;
};
export type PutDeviceDto = {
  displayName?: string | null;
  description?: string | null;
  tags?: PutDeviceTagDto[] | null;
  location?: PutDeviceLocationDto;
};
export type DeviceType =
  | "Unknown"
  | "Custom"
  | "Gateway"
  | "PowerMoniSpot"
  | "PowerMoniMain"
  | "HeatMoniSpot"
  | "TempMoniSpot"
  | "AnalogMoniSpot"
  | "FlowMoniVolume"
  | "TempMoniDC"
  | "FlowMoniEnergy"
  | "FlowMoniSpot"
  | "AnalogMoniActive"
  | "PowerControllerTemp"
  | "MBusSensor";
export type PostDeviceTagDto = {
  key?: string | null;
  value?: string | null;
};
export type PostDeviceLocationDto = {
  latitude?: number;
  longitude?: number;
  accuracyInMeters?: number | null;
  locationSource?: LocationSource | null;
  address?: string | null;
  addressAutoLookup?: boolean | null;
};
export type PostMbusDeviceDto = {
  accountId?: number;
  displayName?: string | null;
  description?: string | null;
  tags?: PostDeviceTagDto[] | null;
  location?: PostDeviceLocationDto;
  mBusSensorType?: MBusSensorType;
  mBusDeviceId?: string | null;
  encryptionKey?: string | null;
};
export type DeviceActivityDirectionFilter = "AsSource" | "AsTarget" | "Both";
export const {
  usePutAnalogDataChannelMutation,
  useGetBatteryStatusHistoryQuery,
  usePutCalibratableElectricCurrentDataChannelsMutation,
  usePutCalibratableFlowDataChannelsMutation,
  usePutDataIntervalConfigurationMutation,
  useGetGatewayConnectionInfoQuery,
  usePutHeatingControlMutation,
  usePutHeatingControlActuatorChannelMutation,
  useGetHeatingControlActuatorChannelWeekplanQuery,
  usePutHeatingControlActuatorChannelWeekplanMutation,
  useDeleteHeatingControlActuatorChannelWeekplanMutation,
  usePutMBusMutation,
  usePutMBusDataChannelMutation,
  usePostOptoEyeMutation,
  useDeleteOptoEyeMutation,
  usePutPluginActuatorChannelConfigurationMutation,
  usePutPluginConfigurationMutation,
  usePutPluginDataChannelConfigurationMutation,
  usePutProductionInfoMutation,
  useGetDeviceQuery,
  usePutDeviceMutation,
  useDeleteDeviceMutation,
  useGetDevicesQuery,
  usePostMbusDeviceMutation,
  useGetDeviceActivityQuery,
  useGetDeviceImageQuery,
  usePutDeviceImageMutation,
  useDeleteDeviceImageMutation,
} = injectedRtkApi;
